import Swiper, { Navigation } from 'swiper';
import 'swiper/css';
import renderProductCards from '../utils/render-product-cards.js';

const selectors = {
  carouselWrapper: '[data-related-products-carousel]',
};

class RelatedProductsCarousel extends HTMLElement {
  constructor() {
    super();

    this.carouselWrappers = this.querySelectorAll(selectors.carouselWrapper);

    this.createObserver();
  }

  createObserver() {
    this.observer = new IntersectionObserver((entries, observer) => {
      if (entries[0].isIntersecting) {
        this.initCarousels();
        renderProductCards();
        observer.unobserve(this);
      }
    });

    this.observer.observe(this);
  }

  initCarousels() {
    this.carousel = new Swiper(selectors.carouselWrapper, {
      modules: [Navigation],
      freeMode: true,
      slidesPerView: 1.2,
      spaceBetween: 10,
      watchOverflow: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        1024: {
          slidesPerView: 4.2,
        },
      },
    });

    window.carousel = this.carousel;
  }
}

customElements.define('related-products-carousel', RelatedProductsCarousel);
